import {
  GetMessagesByObjectIdRequest,
  GetMessagesByObjectIdResponse,
  SendMessageToTicketRequest,
  SendMessageToTicketResponse,
  URL_GET_MESSAGES_BY_OBJECT_ID,
  URL_SEND_MESSAGE_TO_TICKET,
} from "@project/shared-types";
import apiFetchPost from "./apiClient";

export const GetMessagesByObjectIdAPI = async (
  dataRequest: GetMessagesByObjectIdRequest
) => {
  const response = await apiFetchPost<
    GetMessagesByObjectIdRequest,
    GetMessagesByObjectIdResponse
  >(URL_GET_MESSAGES_BY_OBJECT_ID, dataRequest);
  return response;
};

export const SendMessageToTicketAPI = async (
  dataRequest: SendMessageToTicketRequest
) => {
  const response = await apiFetchPost<
    SendMessageToTicketRequest,
    SendMessageToTicketResponse
  >(URL_SEND_MESSAGE_TO_TICKET, dataRequest);
  return response;
};
